import { Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { drivetrainById } from "@/rc/drivetrains";
import { RobotDiagram } from "@/components/rc/RobotDiagram";
import { AttachmentList, ControlsInfo, MotorList, ReadySteps, Tile } from "./SummaryParts";

// The robot's whole driving setup at a glance. Everything is changed through the setup wizard.
export const SetupSummary = ({ cfg, onEdit }) => {
  const dt = drivetrainById(cfg.drivetrain);
  return (
    <div className="mx-auto max-w-5xl space-y-6 px-4 py-6 sm:px-6 lg:px-8 lg:py-8" data-testid="setup-summary">
      <div className="fade-up flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow text-accent dark:text-primary">Robot setup</p>
          <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-testid="setup-drivetrain-name">{dt.name}</h1>
          <p className="mt-1 text-sm text-muted-foreground md:text-base">{dt.subtitle}</p>
        </div>
        <Button onClick={onEdit} size="lg" className="rounded-full" data-testid="setup-edit-button">
          <Wand2 className="mr-1.5 h-4 w-4" />Edit setup
        </Button>
      </div>

      <div className="fade-up delay-1 grid gap-6 lg:grid-cols-2">
        <Tile title="Drivetrain & ports" testId="setup-drivetrain-tile">
          <div className="grid items-center gap-5 sm:grid-cols-[minmax(0,180px)_1fr]">
            <div className="rounded-2xl bg-muted/40 p-4">
              <RobotDiagram dt={dt} cfg={cfg} mode="ports" live className="mx-auto w-full max-w-[160px]" />
            </div>
            <MotorList dt={dt} cfg={cfg} />
          </div>
        </Tile>
        <Tile title="Controls" testId="setup-controls-tile">
          <ControlsInfo dt={dt} cfg={cfg} />
        </Tile>
      </div>

      <Tile title="Attachments" testId="setup-attachments-tile" className="fade-up delay-2">
        <AttachmentList attachments={cfg.attachments || []} />
      </Tile>

      <ReadySteps />
    </div>
  );
};
